import { useEffect, useState } from 'react'

export default function useTimer(deadline: number | undefined, interval = 1000) {
  const [timeLeft, setTimeLeft] = useState<number | undefined>(() =>
    deadline ? Math.max(0, deadline - Date.now()) : undefined
  )

  useEffect(() => {
    if (!deadline) {
      setTimeLeft(undefined)
      return
    }
    let timerHandle
    const updateTimeLeft = () => {
      const newTimeLeft = Math.max(deadline - Date.now(), 0)
      setTimeLeft(newTimeLeft)
      if (newTimeLeft > 0) {
        timerHandle = setTimeout(updateTimeLeft, Math.min(newTimeLeft, interval))
      }
    }
    updateTimeLeft()
    return () => {
      timerHandle && clearTimeout(timerHandle)
    }
  }, [deadline, interval])
  return timeLeft
}
